/* eslint-disable */
import { NO_PREFIX_URL } from '@/utils/http/base-url'
import store from '@/store'
import homeApi from '@/views/home/api'
export default function () {
  return {
    //获取账户列表
    getUserAccount: function (isAlterFlag) {
      // this.$_params.iAccountResponse 首页加载时初始化
      const { Flag, iAccountInfo } = store.state.account.accountResponse
      if (Flag === '0') {
        if (isAlterFlag) {
          this.$talert("您已经超过年费最晚期限，请对企业扣费账户进行充值，否则无法进行转账！")
          return
        }
      }
      const list = []
      $.each(iAccountInfo, (index, item) => {
        list.push(item)
        // 如果是电商账号，加一条记录
        if (item.isEc == 'Y') {
          var iAccount = JSON.parse(JSON.stringify(item))
          iAccount.accountType = 'MSBD'
          list.push(iAccount)
        }
      })
      this.$_params.iAccountInfo = list
      return list
    }.bind(this),
    // 获取账户余额
    getAccountBalance: async function (accountNo) {
      try {
        const res = await homeApi.getUserAccountBalance({
          accountNo,
          currentBusinessCode: '10100000'
        })
        return res.balanceAvailable || 0
      } catch (e) {
        console.error(e)
        return 0
      }
      // var balanceAvailable
      // this.$_core.ajax({
      //   url: `${process.env.BASE_URL}${NO_PREFIX_URL}/accountBalanceQuery.do`,
      //   data: {
      //     'accountNo': accountNo,
      //     'currentBusinessCode': '10100000'
      //   },
      //   type: 'post',
      //   async: false
      // }).done(function (data) {
      //   // 接口报错 或者 余额不大于0 就返回 0，否则就返回正常余额
      //   if (data.ec != '0') {
      //     balanceAvailable = 0
      //   } else {
      //     balanceAvailable = parseFloat(data.balanceAvailable)
      //   }
      // })
      // return balanceAvailable
    }.bind(this),
    // 根据$_params中的枚举 生成select的dom结构
    getSelect: function (appName, selectCode, filter, blankSelect, defaultMsg) {
      var html = "";
      var map = this.$_params[appName];
      if (!map) {
        this.$talert("param: " + appName + " not defined!");
        return null;
      }

      if (blankSelect) {
        var msg = defaultMsg || '请选择';
        html += "<option value=\"\">" + msg + "</option>";
      }

      for (var key in map) {
        var value = map[key];
        if (filter) {
          if (filter.include(key))
            continue;
        }
        if (selectCode && selectCode == key) {
          html += "<option value=\"" + key + "\" selected=\"selected\">" + value + "</option>";
        } else {
          html += "<option value=\"" + key + "\" >" + value + "</option>";
        }
      }
      return html;
    }.bind(this),

    /**
     * 按币种生成账户列表
     */
    getSessionAccountSelectByCurrency: function (currencyType, isBlankSelect, rightIndex, isAlterFlag, accFlag) {

      return this.$_params.getSessionAccountSelectByAccType('ALL', isBlankSelect, rightIndex, isAlterFlag, accFlag, '1', currencyType);
    }.bind(this),
    getSessionAccountSelectByCurrency_obj: function (currencyType, isBlankSelect, rightIndex, isAlterFlag, accFlag) {

      return this.$_params.getSessionAccountSelectByAccType_obj('ALL', isBlankSelect, rightIndex, isAlterFlag, accFlag, '1', currencyType);
    }.bind(this),
    /**
    * 所有账户-获取列表的select结构
    * @return {string} select形式的dom结构
    */
    getSessionAccountSelect: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      try {
        if (typeof (rightIndex) != "undefined") {
          return this.$_params.getSessionAccountSelectByAccType(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          return this.$_params.getSessionFilterAccountSelect(isBlankSelect);
        }
      } catch (e) {
        return this.$_params.getSessionFilterAccountSelect(isBlankSelect);
      }
    }.bind(this),
    /**
    * 所有账户-包含电商账户
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_hasD: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {

      try {
        if (typeof (rightIndex) != "undefined") {
          return this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          return this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        return this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
    }.bind(this),
    /**
    * 所有账户-包括电商账户 但不包括6000账户  === typeA数组
    * 首页按照typeA(不包含6000账户，无论余额是否为0) typeC typeD 的分类数组展示
    * 跨行汇出 账户信息查询这两个页面展示所有账户(包括6000账户 但6000账户余额不能为0)
    * 其他页面 根据需求看是否展示电商账户，但一定不展示6000账户
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_hasD_new: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj,(key) => {
        // if (/MSBD/.test(key)) delete obj[key]
        // 删除6000账户
        if (/^6000/.test(key)) delete obj[key]
      })
      return obj
    }.bind(this),
    /**
    * 所有账户-不包括电商账户 且不包括余额为0的6000账户
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj,async (key) => {
        if (/MSBD/.test(key)) delete obj[key]
        // bc-a 新增逻辑：6000开头且账户余额为0的账户隐藏
        if (/^6000/.test(key)) {
          var accountBalance = await this.$_params.getAccountBalance(key.split('|')[0])
          if (Number(accountBalance) <= 0) {
            delete obj[key]
          }
        }
      })
      return obj
    }.bind(this),
     /**
    * 所有账户-不包括电商账户 且不包括6000账户
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_new: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj,(key) => {
        if (/MSBD/.test(key)) delete obj[key]
        if (/^6000/.test(key)) delete obj[key]
      })
      return obj
    }.bind(this),
    /**
    * 所有账户-不包括电商账户（该方法与上面的区别在于是否显示余额小于等于0的B/C账户）
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_includeBC: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj, (key) => {
        if (/MSBD/.test(key)) delete obj[key]
        // bc-a 新增逻辑：6000开头且账户余额为0的账户隐藏
        // if (/^6000/.test(key)) {
        //   var accountBalance = this.$_params.getAccountBalance(key.split('|')[0])
        //   if (Number(accountBalance) <= 0) {
        //     delete obj[key]
        //   }
        // }
      })
      return obj
    }.bind(this),
    /**
    * 某一类账户-根据正则表达式获取某一类账户(A-S B-MSB C-MSBC)
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_only: function (reg, currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj, (key) => {
        if (!reg.test(key)) delete obj[key]
      })
      return obj
    }.bind(this),
    /**
    * 电商账户-根据正则表达式/MSBD/获取电商账户
    * @return {object} key-value形式的对象
    */
    getSessionAccountSelect_obj_only_d: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag) {
      var obj = {}
      try {
        if (typeof (rightIndex) != "undefined") {
          obj = this.$_params.getSessionAccountSelectByAccType_obj(currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, '1');
        } else {
          obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
        }
      } catch (e) {
        obj = this.$_params.getSessionFilterAccountSelect_obj(isBlankSelect);
      }
      $.each(obj, (key) => {
        if (!/MSBD/.test(key)) delete obj[key]
      })
      return obj
    }.bind(this),
    /**
    * 币种 select形式的dom结构
    * @param {string} currencyFilter 币种过滤 过滤外币和人民币
    * @param {boolean} isBlankSelect 目标下拉框是否为空select
    * @param {number} rightIndex 账户权限的索引位 从1开始
    *                            rightIndex=0为需要所有权限的账户
    * 						               rightIndex=1为需要有查询权限的账户
    * 						               rightIndex=2为需要有付款权限的账户
    * 	 					               rightIndex=3为需要有代发代扣权限的账户
    * @param {string} CB_AccountType_Right 账户类型过滤 0 所有账户 1 只要活期账户在See@lily.param.
    */
    getSessionAccountSelectByAccType: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, CB_AccountType_Right, currencyType) {
      //var accountList = this.$_core.sessionData.iAccountInfo;
      var accountList = this.$_params.getUserAccount(isAlterFlag);
      var html = '';
      if (isBlankSelect) {
        html += "<option value=\"\">请选择</option>"
      }
      $.each(accountList, (i, singleAccInfo) => {
        var right = singleAccInfo.accountRight;
        if (rightIndex == 0) { //取所有账户
          html += this.$_params.getAccountOption(singleAccInfo, CB_AccountType_Right, currencyFilter, accFlag, currencyType);
        } else if (rightIndex > 5) {
          //alert("生成账户列表函数（this.$_params.getSessionAccountSelect）参数传入错误！rightIndex超出索引范围！")
        } else if (rightIndex > 0 && rightIndex < 6) { //按条件过滤
          if (right.charAt(rightIndex - 1) == '1') {
            html += this.$_params.getAccountOption(singleAccInfo, CB_AccountType_Right, currencyFilter, accFlag, currencyType);
          }
        } else {
          //alert("生成账户列表函数（this.$_params.getSessionAccountSelect）参数传入错误！")
        }
      });
      return html;
    }.bind(this),
    /**
    * 币种 key-value形式
    */
    getSessionAccountSelectByAccType_obj: function (currencyFilter, isBlankSelect, rightIndex, isAlterFlag, accFlag, CB_AccountType_Right, currencyType) {
      var accountList = this.$_params.getUserAccount(isAlterFlag);
      var obj = {};

      $.each(accountList, (i, singleAccInfo) => {
        var right = singleAccInfo.accountRight;
        var res
        if (rightIndex == 0) { //取所有账户
          res = this.$_params.getAccountOption_obj(singleAccInfo, CB_AccountType_Right, currencyFilter, accFlag, currencyType);
        } else if (rightIndex > 5) {
          alert("生成账户列表函数（this.$_params.getSessionAccountSelect）参数传入错误！rightIndex超出索引范围！")
        } else if (rightIndex > 0 && rightIndex < 6) { //按条件过滤
          if (right.charAt(rightIndex - 1) == '1') {
            res = this.$_params.getAccountOption_obj(singleAccInfo, CB_AccountType_Right, currencyFilter, accFlag, currencyType);
          }
        } else {
          //alert("生成账户列表函数（this.$_params.getSessionAccountSelect）参数传入错误！")
        }
        if (res) {
          obj[res.key] = res.val
        }
      });
      return obj;
    }.bind(this),
    // 转账功能  手续费支付方式 下拉框  by  zhangxin
    getchargeFeeSelect: function () {
      // var chargeFeeList =[{"chargeFeeId":"B" ,"chargeFeeDetail":"收款人-BEN"} ,{"chargeFeeId":"O" ,"chargeFeeDetail":"汇款人-OUR"} ,{"chargeFeeId":"S" ,"chargeFeeDetail":"共同-SHA"}];
      var chargeFeeList = [{
        "chargeFeeId": "S",
        "chargeFeeDetail": "共同-SHA"
      }];
      var html = '';
      //html += "<option value=\"\">请选择</option>";
      $.each(chargeFeeList, (i, singleAccInfo) => {
        var thisChargeFeeId = singleAccInfo.chargeFeeId;
        var thisChargeFeeDetail = singleAccInfo.chargeFeeDetail;
        html += "<option value=\"" + thisChargeFeeId + "\" >" + thisChargeFeeDetail + "</option>";
      });
      return html;

    }.bind(this),
    //filterName唯一,filterValue可选多个值用";"隔开
    getSessionFilterAccountSelect1: function (blankSelect, filterName, filterValue, rightFilter) {
      //var accountList = this.$_core.sessionData.iAccountInfo;
      var accountList = this.$_params.getUserAccount();
      var html = '';
      var filter = false;
      var fnameArray = [];
      var fvalueArray = [];

      if (blankSelect)
        html += "<option value=\"\">请选择</option>";

      if (!this.$_params.isEmpty(filterName)) {
        filter = true;
        //	fnameArray=filterName.split(";");
        fnameArray = filterName;
        fvalueArray = filterValue.split(";");

      }
      $.each(accountList, (i, singleAccInfo) => {
        var thisAccountNo = singleAccInfo.accountNo;
        var thisAccountAlias = singleAccInfo.accountAlias;
        var thisAccountRight = singleAccInfo.accountRight;
        if (this.$_params.isEmpty(thisAccountAlias)) {
          thisAccountAlias = "";
        }
        var thisPass = false;
        if (filter) {
          for (var j = 0; j < fvalueArray.length; j++) {
            if (fvalueArray[j] == singleAccInfo[fnameArray]) {
              thisPass = true;
              break;
            }
          }
        }
        if (!this.$_params.isEmpty(rightFilter) && thisPass) {
          thisPass = thisAccountRight.charAt(parseInt(rightFilter)) == '1';
        }

        if (thisPass) {
          if (thisAccountAlias == '' || thisAccountAlias == null) {
            html += "<option value=\"" + thisAccountNo + "\" >" + thisAccountNo + "</option>";
          } else {
            html += "<option value=\"" + thisAccountNo + "\" >" + thisAccountNo + "[" + thisAccountAlias + "]</option>";
          }

        }
      });
      return html;
    }.bind(this),
    /**
     *生成账户列表- 过滤币种  currencyFilter为null或者非1，只显示人民币账户
     *														currencyFilter为非0时ALL显示所有币种账户
     *																						其他只显示外币账户
     */
    getAccountOption: function (obj, CB_AccountType_Right, currencyFilter, accFlag, currencyType) {
      var ccy = $.trim(obj.currencyType);
      if (currencyFilter) {
        if (currencyFilter == 'ALL') {
          return this.$_params.getAccountOption_(obj, CB_AccountType_Right, accFlag, currencyType);
        } else {
          if (ccy != "01") {
            return this.$_params.getAccountOption_(obj, CB_AccountType_Right, accFlag, currencyType);
          }
        }
      } else {
        if (ccy == "01") {
          return this.$_params.getAccountOption_(obj, CB_AccountType_Right, accFlag, currencyType);
        }
      }
    }.bind(this),
    getAccountOption_obj: function (obj, CB_AccountType_Right, currencyFilter, accFlag, currencyType) {
      var ccy = $.trim(obj.currencyType);
      if (currencyFilter) {
        if (currencyFilter == 'ALL') {
          return this.$_params.getAccountOption__obj(obj, CB_AccountType_Right, accFlag, currencyType);
        } else {
          if (ccy != "01") {
            return this.$_params.getAccountOption__obj(obj, CB_AccountType_Right, accFlag, currencyType);
          }
        }
      } else {
        if (ccy == "01") {
          return this.$_params.getAccountOption__obj(obj, CB_AccountType_Right, accFlag, currencyType);
        }
      }
    }.bind(this),
    /**
     * 生成账户列表-过滤账户类型
     */
    getAccountOption_: function (obj, CB_AccountType_Right, accFlag, currencyType) {
      var config_ = this.$_params.getDisplay("CB_AccountType_Right", CB_AccountType_Right);
      var html_ = "";
      var config_array = config_.split(",");
      for (var i = 0; i < config_array.length; i++) {
        if (config_array[i] == obj.accountDepositType) {
          if (this.$_format.isEmpty(obj.accountAlias)) {
            var accountName = obj.accountName;
            var accountAlias = "";
          } else {
            var accountName = obj.accountAlias;
            var accountAlias = obj.accountAlias;
          }

          var accountType = this.$_params.getDisplay("CB_ACCOUNT_KIND", obj.accountType);
          if (accFlag) {
            html_ = '<option value="' + obj.accountNo + '">' + obj.accountNo + '</option>';
          } else {
            if (accountType == undefined || accountType == '' || accountType == null) {
              html_ = '<option value="' + obj.accountNo + "|" + obj.currencyType + "|" + obj.accountName + "|" + accountAlias + "|" + obj.accountType + '">' + obj.accountNo + '/' + obj.currencyType + '/' + accountName + '</option>';
            } else {
              html_ = '<option value="' + obj.accountNo + "|" + obj.currencyType + "|" + obj.accountName + "|" + accountAlias + "|" + obj.accountType + '">' + obj.accountNo + '/' + accountType + '/' + obj.currencyType + '/' + accountName + '</option>';
            }
          }

          if (currencyType && obj.currencyType != currencyType) {
            html_ = ''
          }
        }
      }
      return html_;
    }.bind(this),
    /**
     * 生成账户列表-过滤账户类型，返回 { key: kye, val: value } 对象, 适用于lily.select.js
     */

    getAccountOption__obj: function (obj, CB_AccountType_Right, accFlag, currencyType) {
      var config_ = this.$_params.getDisplay("CB_AccountType_Right", CB_AccountType_Right);
      var res = {};
      var config_array = config_.split(",");

      if (currencyType && obj.currencyType != currencyType) {
        return false
      }

      for (var i = 0; i < config_array.length; i++) {
        if (config_array[i] == obj.accountDepositType) {
          if (this.$_format.isEmpty(obj.accountAlias)) {
            var accountName = obj.accountName;
            var accountAlias = "";
          } else {
            var accountName = obj.accountAlias;
            var accountAlias = obj.accountAlias;
          }

          var accountType = this.$_params.getDisplay("CB_ACCOUNT_KIND", obj.accountType);

          if (accFlag) {
            res = {
              key: obj.accountNo,
              val: obj.accountNo
            }
          } else if (!accountType) {
            res = {
              key: obj.accountNo + "|" + obj.currencyType + "|" + obj.accountName + "|" + accountAlias + "|" + obj.accountType,
              val: obj.accountNo + '/' + obj.currencyType + '/' + accountName
            }
          } else {
            res = {
              key: obj.accountNo + "|" + obj.currencyType + "|" + obj.accountName + "|" + accountAlias + "|" + obj.accountType,
              val: obj.accountNo + '/' + accountType + '/' + obj.currencyType + '/' + accountName
            }
          }

        }
      }
      return res
    }.bind(this),

    getAccountOpenNode: function (accountNo) {
      var accountList = this.$_params.getUserAccount();

      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = item.accountOpenNode;

          return text;
        }
      });
      return text;

    }.bind(this),
    getAccountParam: function (accountNo, param) {
      var accountList = this.$_params.getUserAccount();

      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = item.param;

          return text;
        }
      });
      return text;

    }.bind(this),
    getAccountState: function (accountNo) {
      var accountList = this.$_params.getUserAccount();

      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = item.accountState;

          return text;
        }
      });
      return text;

    }.bind(this),
    getCurrencyType: function (accountNo) {
      //var accountList = this.$_core.sessionData.iAccountInfo;
      var accountList = this.$_params.getUserAccount();

      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = this.$_params.getDisplay("GRB_CURRENCY_TYPE", item.currencyType);
          //					text = text + "/" + this.$_params.getDisplay( "CshFlg", this.CshFlg );
          return text;
        }
      });
      return text;

    }.bind(this),
    getCurrencyCode: function (accountNo) {
      var accountList = this.$_params.getUserAccount();;

      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = item.currencyType;

          return text;
        }
      });
      return text;

    }.bind(this),
    getSessionAccountByRight: function (blankSelect, rightFilter) {

      return this.$_params.getSessionFilterAccountSelect(blankSelect, '', '', rightFilter);
    }.bind(this),
    getSessionFilterAccountSelect: function (blankSelect, filterName, filterValue, rightFilter) {
      //var accountList = this.$_core.sessionData.iAccountInfo;
      var accountList = this.$_params.getUserAccount();
      var html = '';
      var filter = false;
      var fnameArray = [];
      var fvalueArray = [];

      if (blankSelect)
        html += "<option value=\"\">请选择</option>";

      if (!this.$_params.isEmpty(filterName)) {
        filter = true;
        fnameArray = filterName.split(";");
        fvalueArray = filterValue.split(";");
        if (fnameArray.length != fvalueArray.length) {
          this.$talert("获取账号的参数输入非法！");
          return false;
        }
      }
      $.each(accountList, (i, singleAccInfo) => {
        var thisAccountNo = singleAccInfo.accountNo;
        var thisAccountAlias = singleAccInfo.accountAlias;
        var thisAccountRight = singleAccInfo.accountRight;
        if (this.$_params.isEmpty(thisAccountAlias)) {
          thisAccountAlias = "";
        }
        var thisPass = true;
        if (filter) {
          for (var j = 0; j < fnameArray.length; j++) {
            if (fvalueArray[j] != singleAccInfo[fnameArray[j]]) {
              thisPass = false;
            }
          }
        }
        if (!this.$_params.isEmpty(rightFilter) && thisPass) {
          thisPass = thisAccountRight.charAt(parseInt(rightFilter)) == '1';
        }

        if (thisPass) {
          if (thisAccountAlias == '' || thisAccountAlias == null) {
            html += "<option value=\"" + thisAccountNo + "\" >" + thisAccountNo + "</option>";
          } else {
            html += "<option value=\"" + thisAccountNo + "\" >" + thisAccountNo + "[" + thisAccountAlias + "]</option>";
          }

        }
      });
      return html;
    }.bind(this),
    getSessionFilterAccountSelect_obj: function (blankSelect, filterName, filterValue, rightFilter) {
      //var accountList = this.$_core.sessionData.iAccountInfo;
      var accountList = this.$_params.getUserAccount();
      var html = {};
      var filter = false;
      var fnameArray = [];
      var fvalueArray = [];

      // if (blankSelect)
      //     html += "<option value=\"\">请选择</option>";

      if (!this.$_params.isEmpty(filterName)) {
        filter = true;
        fnameArray = filterName.split(";");
        fvalueArray = filterValue.split(";");
        if (fnameArray.length != fvalueArray.length) {
          this.$talert("获取账号的参数输入非法！");
          return false;
        }
      }
      $.each(accountList, (i, singleAccInfo) => {
        var thisAccountNo = singleAccInfo.accountNo;
        var thisAccountAlias = singleAccInfo.accountAlias;
        var thisAccountRight = singleAccInfo.accountRight;
        if (this.$_params.isEmpty(thisAccountAlias)) {
          thisAccountAlias = "";
        }
        var thisPass = true;
        if (filter) {
          for (var j = 0; j < fnameArray.length; j++) {
            if (fvalueArray[j] != singleAccInfo[fnameArray[j]]) {
              thisPass = false;
            }
          }
        }
        if (!this.$_params.isEmpty(rightFilter) && thisPass) {
          thisPass = thisAccountRight.charAt(parseInt(rightFilter)) == '1';
        }

        if (thisPass) {
          if (thisAccountAlias == '' || thisAccountAlias == null) {
            html[thisAccountNo] = thisAccountNo
          } else {
            html[thisAccountNo] = thisAccountNo + "[" + thisAccountAlias + "]"
          }

        }
      });
      return html;
    }.bind(this),

    getAccountName: function (accountNo) {
      var accountList = this.$_params.getUserAccount();
      var text = "";

      $.each(accountList, (index, item) => {

        if (item.accountNo == accountNo) {

          text = item.accountName;

          return text;
        }
      });
      return text;
    }.bind(this),
    /*
		getCurrencyType：function( accountNo ) {
			var accountList = this.$_core.sessionData.iAccountInfo;
			var text = "";
			$.each(accountList, function() {
				if(this.accountNo == accountNo) {
					text = this.getDisplay( "CURRENCY_TYPE", this.currencyType );
					return false;
				}
			});
			return text;
		}.bind(this),*/

    getDisplay: function (appName, appValue) {
      var map = this.$_params[appName];
      if (!map) {
        //alert( "Liana.param: " + appName + " not defined!");
        return null;
      }
      appValue = $.trim(appValue);
      if (map[appValue] == undefined || map[appValue] == 'undefined') {
        return appValue;
      }
      return map[appValue];
    }.bind(this),

    isEmpty: function (input) {
      if (input == null || this.$_params.trim(input).length == 0 || input == 'null')
        return true;
      else
        return false;
    }.bind(this),

    trim: function (input) {
      return input.replace(/(^\s*)|(\s*$)/g, "");
    }.bind(this),

    isEmptyObject: function (obj) {
      for (var name in obj) {
        return false;
      }
      return true;
    }.bind(this),
    nvl: function (s, replaceString) {
      if (this.$_params.isEmpty(s))
        return replaceString;
      else
        return s;
    }.bind(this),

    getLogInfoDisplay: function (bsnCode, logInfo, logData) {
      var logInfoResult = '';
      var re = new RegExp("\\^", "g");
      var un = new RegExp("\\undefined", "g");
      var logInfoMsg = $.trim((logInfo.replace(re, '')).replace(un, ''));
      if (logInfoMsg != null && logInfoMsg != '') {
        $($(logData).find('log')).each(function (index) {
          var businessCode = $(this).attr('businessCode');
          var logInformation = $(this).attr('logInformation');
          if (businessCode == bsnCode) {
            if ((logInformation == '' || logInformation == null) && (logInfoMsg == '' || logInfoMsg == null)) {
              logInfoResult = '';
            } else {
              if (logInfoMsg == '' || logInfoMsg == null) {
                if (logInformation.indexOf("^^") != -1) {
                  var logInformationArr = logInformation.split("^^");
                  logInformation = '';
                  for (var i = 0; i < logInformationArr.length; i++) {
                    logInformation += logInformationArr[i];
                  }
                }
                logInfoResult = logInformation;

              } else if (logInformation == '' || logInformation == null) {
                if (logInfo.indexOf("^^") != -1) {
                  var logInfoArr = logInfo.split("^^");
                  logInfo = '';
                  for (var i = 0; i < logInfoArr.length; i++) {
                    if (logInfoArr[i] == "undefined" || logInfoArr[i] == undefined || logInfoArr[i] == "null" || logInfoArr[i] == null) {
                      logInfo += '';
                    } else {
                      logInfo += logInfoArr[i];
                    }
                  }
                }
                logInfoResult = logInfo;
              } else {
                var logInformationFlog = logInformation.split("^^");
                var logInfoFlog = logInfo.split("^^");

                var len = logInformationFlog.length;

                for (var i = 0; i < len; i++) {

                  if (logInformationFlog[i].indexOf("**") != -1) {
                    logInformationFlogArr = logInformationFlog[i].split("**");
                    logInformationFlog[i] = logInformationFlogArr[0];
                    logInfoFlog[i] = this.$_params.getDisplay(logInformationFlogArr[1], logInfoFlog[i]);
                    if (!logInfoFlog[i])
                      logInfoFlog[i] = "";
                  }
                  if (logInfoFlog[i] == "undefined" || logInfoFlog[i] == undefined || logInfoFlog[i] == "null" || logInfoFlog[i] == null) {
                    var flagTemp = logInformationFlog[i] + '' + "；";
                  } else {
                    var flagTemp = logInformationFlog[i] + logInfoFlog[i] + "；";
                  }
                  logInfoResult += flagTemp;
                }
              }
            }

            return logInfoResult;

          }
        });
      } else {
        logInfoResult = '';
      }


      if (logInfoResult == '' && logInfoMsg != '' && logInfoMsg != null) {
        logInfoResult = logInfo;
      }
      return logInfoResult;
    }.bind(this),

    getLogInfoCustomerId: function (logInfoDisplay) {
      var customerId = "";
      if (logInfoDisplay != null && logInfoDisplay != "") {
        var re = new RegExp("CB\\d{8}", "g");
        try {
          customerId = re.exec(logInfoDisplay)[0];
        } catch (e) {

        }
      }
      return customerId;
    }.bind(this),
    getLogInfoUserId: function (logInfoDisplay) {
      var userId = "";
      if (logInfoDisplay != null && logInfoDisplay != "") {
        try {
          userId = logInfoDisplay.substring(logInfoDisplay.length - 7, logInfoDisplay.length - 1);
        } catch (e) {

        }
      }
      return userId;
    }.bind(this),
    translateSysFlag: function (errorCode) {
      var errorTran = errorCode.substring(0, 6);
      var errorList = this.$_params['ERRCODE_SYS_FLAG'];
      for (var key in errorList) {
        if (key == errorTran) {
          var sys = this.$_params.getDisplay('ERRCODE_SYS_FLAG', errorTran);
          return sys + '▪' + errorCode.substring(6);
        }
      }
      return errorCode;
    }.bind(this),

    getAccountAliasName: function (accountNo) {
      var accountList = this.$_params.getUserAccount();
      var text = "";
      $.each(accountList, (index, item) => {
        if (item.accountNo == accountNo) {
          if (item.accountAlias == "" || item.accountAlias == null || item.accountAlias == null) {
            text = item.accountName;
          } else {
            text = item.accountAlias;
          }
          return text;
        }
      });
      return text;
    }.bind(this)
  }
}
